const Print = () => {
  return (
    <div
      className={
        'absolute top-[33%] left-[33%] h-[34%] w-[34%] bg-black shadow-(--shadow-print) bg-blend-overlay bg-cover rounded-[50%]'
      }
    />
  );
};
export default Print;
